import { useCallback, useState } from 'react'
import { RequestStatus } from '@sales-center/common'
import { fetchActivityHistory } from '../effects/fetchActivityHistory.effect'
import { useActivitiesContext } from '../context'
import { filtersToSearchInput } from '../effects/filtersToSearchInput'
import { ENTITY_TYPES } from '@sales-center/common'

export function useRefreshActivityHistory(
  entityId: number,
  entityType: ENTITY_TYPES,
) {
  const [{ filters }, dispatch] = useActivitiesContext()
  const [status, setStatus] = useState<RequestStatus>('idle')

  const refreshHistory = useCallback(async () => {
    setStatus('loading')
    const search = filtersToSearchInput(entityId, entityType, filters)

    const action = await fetchActivityHistory(search)
    dispatch(action)
    setStatus('idle')
  }, [dispatch, entityId, entityType, filters])

  return { refreshHistory, status } as const
}
